import { ResHandle, formatMenu } from '@/utils/utils'
import router from '@/router_config'
import types from '../types'

const state = {
  infoIcon: {
    total_activated_students: 'student',
    total_classes: 'classNum',
    total_works: 'info',
    avarage_score: 'score',
    high_score: 'highest',
    behavior_score: 'highest'
  },
  scoreName: {
    activated_students: '激活学生数',
    total_classes: '班级数',
    total_works: '作品数',
    average_score: '作品平均分',
    high_score: '作品最高分',
    behavior_score: '课堂表现',
    total_periods: '上课数',
    total_teachers: '教师数'
  },
  unit_scoreName: {
    unit_count: '单位数',
    class_count: '班级数',
    activat_student_count: '激活学生数',
    attend_class_count: '上课数',
    teacher_count: '教师数',
    teacher_increased_count: '昨日新增教师数',
    student_increased_count: '昨日新增学生数',
    class_increased_count: '昨日新增班级数',
    work_count: '作品数',
    consume_voucher_count: '消耗券',
    give_voucher_count: '赠送券',
    purchase_voucher_count: '购买券',
    coupons_voucher_count: '返券',
    refund_voucher_count: '退款券'
  },

  menuRouter: {
    dashboard: 'dashboard',
    10: 'teacherManage',
    11: 'classManage',
    12: 'studentManage',
    13: 'workManage',
    14: 'myWork',
    15: 'courseManage',
    17: 'tool',
    19: 'help',
    16: 'courseManage',
    18: 'offlineTool',
    20: 'unitManage',
    21: 'forum',
    22: 'learningStatistics'
  },
  menuIcon: {
    dashboard: '-2px -2px',
    10: '-2px -30px',
    11: '-2px -58px',
    12: '-2px -86px',
    14: '-2px -196px',
    13: '-2px -196px',
    15: '-2px -113px',
    17: '-2px -140px',
    19: '-2px -168px',
    16: '-2px -113px',
    20: '-2px -113px',
    22: '-2px -225px'
  },
  menuName: {
    dashboard: '教室首页',
    10: '教师管理',
    11: '班级管理',
    12: '学生管理',
    13: '作品管理',
    14: '我的作品',
    17: '创作工具',
    15: '课程中心',
    22: '学情报告',
    19: '帮助与反馈',
    16: '我的课程',
    18: '离线创作工具',
    21: '教师论坛',
    20: '单位列表'
  },
  unit_menuName: {
    dashboard: '教室首页',
    20: '单位列表',
    10: '教师列表',
    11: '班级列表',
    12: '学生列表'
  },
  menu: [],
  entry: [],
  scoreBoard: [],
  commonEntry: [
    {
      name: '创作工具',
      path: 'tool',
      background: 'linear-gradient(-222deg, #5EDEEF 0%, #40BCEA 100%)',
      position: '-30px -242px'
    },
    {
      name: '离线创作工具',
      path: 'offlineTool',
      background: 'linear-gradient(-222deg, #98EB5B 0%, #79C342 100%)',
      position: '-30px -290px'
    },
    {
      name: '教师论坛',
      path: 'forum',
      background: 'linear-gradient(-222deg, #41DA95 0%, #29B174 100%)',
      position: '-30px -242px'
    }
  ],
  entryBackground: {
    10: 'linear-gradient(-222deg, #4BE28E 0%, #00C4AA 100%)',
    11: 'linear-gradient(-222deg, #FF9E2D 0%, #FF721C 100%)',
    12: 'linear-gradient(-222deg, #FFE155 0%, #FFBB11 100%)',
    13: 'linear-gradient(-222deg, #F69EE9 0%, #DC6CC4 100%)',
    14: 'linear-gradient(-222deg, #F69EE9 0%, #DC6CC4 100%)',
    15: 'linear-gradient(-222deg, #FFD1B8 0%, #FFAC61 100%)',
    16: 'linear-gradient(-222deg, #FFD1B8 0%, #FFAC61 100%)',
    17: 'linear-gradient(-222deg, #5EDEEF 0%, #40BCEA 100%)',
    18: 'linear-gradient(-222deg, #98EB5B 0%, #79C342 100%)',
    21: 'linear-gradient(-222deg, #41DA95 0%, #29B174 100%)',
    22: 'linear-gradient(-222deg, #4CEBC9 0%, #10CAEA 100%)'
  },
  entryIconPosition: {
    10: '-30px -2px',
    11: '-30px -98px',
    12: '-30px -50px',
    13: '-30px -146px',
    14: '-30px -146px',
    15: '-30px -194px',
    16: '-30px -194px',
    17: '-30px -242px',
    18: '-30px -290px',
    21: '-30px -385px',
    22: '-30px -340px'
  },
  avatar_url: '',
  id: '',
  role_id: '',
  unit_name: '',
  real_name: '',
  phone: '',
  username: '',
  is_default_password: ''
}

// actions
const actions = {
  // login method
  async login({ commit }, payload) {
    const data = {
      identity: payload.username,
      // identify: payload.username,
      password: payload.password
    }
    const res = await window.API.post('/edu/zone/sign/password', data)
    if (res.status === 200) {
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('has_password', true)
    }
    return ResHandle(res)
  },
  // log out method
  async logout({ commit }) {
    const res = await window.API.post('/api/user/logout', {})
    if (res.status === 204) {
      commit(types.Logout)
    }
    return ResHandle(res)
  },
  // bind mobile
  async bindMobile({ commit }, data) {
    await API.patch(`/edu/zone/binding`, data)
  },
  // edit password method
  async editPassword({ commit }, data) {
    await API.patch(`/edu/zone/password`, data)
  },
  // mobie login
  async mobileLogin({ commit }, data) {
    const res = await API.post('/edu/zone/sign/captcha', data)
    return res
  },
  // get captcha 登录获取的验证码
  getVerificationCode({ commit }, phone_number) {
    const phoneNumber = phone_number
    window.captchaObj.verify()
    window.captchaObj.onSuccess(function() {
      const result = window.captchaObj.getValidate()
      window.API.post(CONFIG.api_backend + '/tiger/accounts/captcha/login', {
        geetest_challenge: result.geetest_challenge,
        geetest_validate: result.geetest_validate,
        geetest_seccode: result.geetest_seccode,
        phone_number: phoneNumber
      }).then(res => {
        return res
      })
    })
  },
  // get self
  async getZoneSelf({ commit }) {
    const res = await API.get(`/edu/zone`)
    if (res.status < 400) {
      if (res.data.role_id === 40002) {
        // TODO: fix this
        router.push('/data_graph')
      }
      commit('setSelf', res.data)
      localStorage.setItem('role_id', state.role_id)
    }
  },
  // 首次登陆设置密码
  async initPassword({ commit }, pwd) {
    const res = await API.post(`/edu/zone/password/initial`, { password: pwd })
    return res
  },
  // 修改密码获取的验证码
  async getPwdCaptcha({ commit }, mobile) {
    const res = await API.post('/edu/zone/password/update/captcha', {
      phone_number: mobile
    })
    return res
  },
  // 修改密码
  async resetPassword({ commit }, data) {
    const res = await API.patch(`/edu/zone/password/update`, data)
    return res
  },
  // 获取绑定验证码
  async getBindingCaptcha({ commit }, mobile) {
    const res = await API.post('/edu/zone/phone/binding/captcha', {
      phone_number: mobile
    })
    return res
  },
  // 绑定手机号
  async bindingMobile({ commit }, data) {
    const res = await API.patch('/edu/zone/phone/binding', data)
    return res
  },
  // 获取菜单
  async getMenu({ commit, rootState }) {
    const res = await API.get('/edu/zone/homepage/menus')
    commit('setMenu', res.data)
  },
  // 获取统计
  // async get

  // 获取首页信息
  async getRecentRecord({ commit }) {
    const unit_id = localStorage.getItem('role_id')
    if (unit_id === '40001') {
      const res = await API.get('/edu/zone/channel/agent/operation/records')
      if (res.status < 400) {
        return res.data.items
      }
    } else {
      const res = await API.get('/edu/zone/operation/records')
      if (res.status < 400) {
        return res.data.items
      }
    }
  },
  // 获取基础统计信息
  async getStatistic({ commit }) {
    const unit_id = localStorage.getItem('role_id')
    if (unit_id === '40001') {
      // 获取统计基础数据
      const res = await API.get(
        '/edu/zone/homepage/channel/agent/base/statistic'
      )
      if (res.status < 400) {
        commit('setStatistic', res.data)
        const increaseRes = await API.get(
          '/edu/zone/homepage/channel/agent/increase/statistic'
        )
        if (increaseRes.status < 400) {
          commit('setIncreaseStatistic', increaseRes.data)
        }
      }
    } else {
      const res = await API.get('/edu/zone/homepage/statistic')
      if (res.status < 400) {
        commit('setStatistic', res.data.statistics)
      }
    }
  },
  // 获取消费统计数据
  async getVoucherStatistic({ commit }) {
    const unit_id = localStorage.getItem('role_id')
    if (unit_id === '40001') {
      const res = await API.get(
        '/edu/zone/homepage/channel/agent//voucher/statistic'
      )
      if (res.status < 400) {
        commit('setVoucherStatistic', res.data)
      }
    }
  }
}

// mutations
const mutations = {
  [types.Login](state, data) {
    localStorage.token = data
    state.token = data
  },
  [types.Logout](state) {
    localStorage.removeItem('token')
    localStorage.removeItem('role_id')
    state.token = null
  },
  phone(state, value) {
    state.phone = value
  },
  setMenu(state, data) {
    const unit_id = localStorage.getItem('role_id')
    if (unit_id === '40001') {
      state.menu = []
      const menu = formatMenu(['dashboard', ...data.menus], 21)
      // 设置nav菜单
      menu.forEach(value => {
        state.menu.push({
          i18n: `unit_menuName.${value}`,
          name: state.unit_menuName[value],
          path: state.menuRouter[value],
          position: state.menuIcon[value]
        })
      })
    } else {
      state.menu = []
      const menu = formatMenu(['dashboard', ...data.menus], 21)
      // 设置nav菜单
      menu.forEach(value => {
        state.menu.push({
          i18n: `menuName.${value}`,
          name: state.menuName[value],
          path: state.menuRouter[value],
          position: state.menuIcon[value]
        })
      })
      // 设置快捷入口
      state.entry = []
      data.menus.forEach(value => {
        state.entry.push({
          i18n: `menuName.${value}`,
          name: state.menuName[value],
          path: state.menuRouter[value],
          background: state.entryBackground[value],
          position: state.entryIconPosition[value]
        })
      })
      state.entry = [...state.entry]
    }
  },

  setStatistic(state, data) {
    state.scoreBoard = []
    if (typeof data === 'object') {
      const unit_id = localStorage.getItem('role_id')
      if (unit_id === '40001') {
        Object.keys(data).forEach(key => {
          state.scoreBoard.push({
            i18n: `unit_scoreName.${key}`,
            name: state.unit_scoreName[key],
            icon: state.infoIcon[key],
            value: data[key]
          })
        })
      } else {
        Object.keys(data).forEach(key => {
          state.scoreBoard.push({
            i18n: `scoreName.${key}`,
            name: state.scoreName[key],
            icon: state.infoIcon[key],
            value: data[key]
          })
        })
      }
    }
  },
  setIncreaseStatistic(state, data) {
    if (typeof data === 'object') {
      Object.keys(data).forEach(key => {
        state.scoreBoard.push({
          i18n: `unit_scoreName.${key}`,
          name: state.unit_scoreName[key],
          icon: state.infoIcon[key],
          value: data[key]
        })
      })
    }
  },
  setVoucherStatistic(state, data) {
    if (typeof data === 'object') {
      Object.keys(data).forEach(key => {
        state.scoreBoard.push({
          name: state.unit_scoreName[key],
          icon: state.infoIcon[key],
          value: data[key]
        })
      })
    }
  },
  setSelf(state, data) {
    state.avatar_url =
      data.avatar_url || 'http://7xo6t4.com2.z0.glb.qiniucdn.com/user_0009.png'
    state.id = data.id
    state.role_id = data.role_id
    state.unit_name = data.unit_name
    state.real_name = data.real_name
    state.phone = data.phone
    state.username = data.username
    state.is_default_password = data.reset_password
  }
  // 是否设置密码
}

export default {
  state,
  actions,
  mutations
}
